export const BLOOMBERG_ORIGINALS_SERIES_TYPE = "originals";
export const BLOOMBERG_QUICKTAKE_SERIES_TYPE = "qt";
export const BLOOMBERG_ORIGINALS_SERIES_ID = "bloomberg-originals";
export const NEW_VIDEO_LAYOUT_SERIES_IDS = new Set([
    "quicktake",
    BLOOMBERG_ORIGINALS_SERIES_ID,
]);
export const VERTICAL_VIDEO_NICODE = "VIDPORT";
